import http from '@/api/http'
import { useAuthStore } from '@/stores/auth'

function isAuthOptionalRequest(url = '') {
  if (url.includes('/auth/is-authenticated')) {
    return true
  }
  if (url.includes('/public/')) {
    return true
  }
  if (url.includes('/auth/login') || url.includes('/auth/register')) {
    return true
  }
  return false
}

export function setupHttpInterceptors() {
  http.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status
      const url = error?.config?.url ?? ''

      if (status === 401 && !isAuthOptionalRequest(url)) {
        const authStore = useAuthStore()
        authStore.setUser(null)
      }

      return Promise.reject(error)
    },
  )
}
